import { NewDashboardRoot } from '@crehana/web';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const SidebarWrapper = styled(NewDashboardRoot)<{ heightAuto: boolean }>(
  ({ heightAuto }) => css`
    ${
      heightAuto &&
      css`
      &#sidebar-b2b {
        > div {
          > a {
            height: auto;
            max-height: none;
          }
        }
        ul {
          li {
            button {
              padding-left: 8px;
            }
          }
        }
      }
    `
    }
    &#sidebar-b2b {
      ul {
        li {
          position: relative;
          padding-right: 8px;
          button {
            padding: 0 8px 0 8px;
            ::after {
              top: -37px;
              height: 57px;
              border-width: 3.5px;
            }
          }
        }
      }
    }
  `,
);

export const LogoWrapper = styled.div`
  > div {
    margin: 0;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
